import axios from 'axios';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';

// Operations view of the referral payout ledger. Gated server-side by
// referral_payouts:view (reads) / referral_payouts:manage (mark paid / void).
export const useFetchReferralPayouts = (status, page = 1) => {
  return useQuery(
    ['referral-payouts', { status, page }],
    async () => {
      const res = await axios.get('/referral-payouts', {
        params: { status, page },
      });
      return res.data;
    },
    { keepPreviousData: true },
  );
};

export const useMarkReferralPayoutPaid = () => {
  const queryClient = useQueryClient();
  return useMutation(
    async ({ payoutId, paidAt, paymentReference, paymentMethod }) => {
      const res = await axios.post(`/referral-payouts/${payoutId}/mark-paid`, {
        paidAt,
        paymentReference,
        paymentMethod,
      });
      return res.data;
    },
    {
      onSuccess: () => queryClient.invalidateQueries(['referral-payouts']),
    },
  );
};

// Release a held payout onto the page (held -> eligible). The server re-checks
// that the referrer is an approved partner with signed paperwork attached.
export const useReleaseReferralPayout = () => {
  const queryClient = useQueryClient();
  return useMutation(
    async ({ payoutId }) => {
      const res = await axios.post(`/referral-payouts/${payoutId}/release`);
      return res.data;
    },
    {
      onSuccess: () => queryClient.invalidateQueries(['referral-payouts']),
    },
  );
};

// Void an eligible or held payout (terminal; requires a note explaining why).
export const useMarkReferralPayoutVoid = () => {
  const queryClient = useQueryClient();
  return useMutation(
    async ({ payoutId, note }) => {
      const res = await axios.post(`/referral-payouts/${payoutId}/mark-void`, { note });
      return res.data;
    },
    {
      onSuccess: () => queryClient.invalidateQueries(['referral-payouts']),
    },
  );
};
